import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ErrorAlertState {
  open: boolean;
  title: string;
  message: string;
  details: string;
}

const initialState: ErrorAlertState = {
  open: false,
  title: "",
  message: "",
  details: "",
};

const ErrorAlertSlice = createSlice({
  name: "ErrorAlert",
  initialState,
  reducers: {
    openErrorAlert(
      state,
      action: PayloadAction<{
        title?: string;
        message: string;
        details?: string;
      }>,
    ) {
      state.open = true;
      state.title = action.payload.title || "Error";
      state.message = action.payload.message;
      state.details = action.payload.details || "";
    },
    closeErrorAlert(state) {
      state.open = false;
      state.title = "";
      state.message = "";
      state.details = "";
    },
  },
});

export default ErrorAlertSlice.reducer;
export const { openErrorAlert, closeErrorAlert } = ErrorAlertSlice.actions;
